import Vue from 'vue'
import App from './App.vue'
import router from './router'; // 引入路由配置
import '@vant/touch-emulator';

// 开发环境下导入 dayjs，生产环境使用 CDN
let dayjs;
if (process.env.NODE_ENV !== 'production') {
    dayjs = require('dayjs');
} else {
    // 生产环境下 dayjs 已通过 CDN 加载
    dayjs = window.dayjs;
}

// 开发环境下按需导入 lodash，生产环境使用 CDN
let _;
if (process.env.NODE_ENV !== 'production') {
    // 按需导入 lodash 方法，而不是整个库
    _ = {
        get: require('lodash/get'),
        set: require('lodash/set'),
        debounce: require('lodash/debounce'),
        throttle: require('lodash/throttle'),
        cloneDeep: require('lodash/cloneDeep'),
        // 根据需要添加更多方法
    };
} else {
    // 生产环境下 lodash 已通过 CDN 加载
    _ = window._;
}

// 开发环境下导入 Vant，生产环境使用 CDN
if (process.env.NODE_ENV !== 'production') {
    const Vant = require('vant');
    require('vant/lib/index.css');
    Vue.use(Vant);
} else {
    // 生产环境下 Vant 已通过 CDN 加载，这里只需确保 Vue.use
    Vue.use(window.vant);
}
import initCacheFun from './utils/cache'
import anime from './utils/anime'
import global from './utils/global'
import { getBrowserKeyAsync } from '@/utils/browserUtil';

import '@/permission' // permission control

//图表 echarts 引入
//图表 echarts4引入，下面是5引入
//import * as echarts from 'echarts'
// 开发环境下导入 echarts，生产环境使用 CDN
if (process.env.NODE_ENV !== 'production') {
    //const echarts = require('echarts');
    const echarts = require('echarts/lib/echarts')
    // 引入柱状图组件
    require('echarts/lib/chart/bar')
    require('echarts/lib/chart/pie')
    // 引入提示框和title组件
    require('echarts/lib/component/tooltip')
    require('echarts/lib/component/title')
    require('echarts/lib/component/legend')
    require('echarts/lib/component/grid')
    Vue.prototype.$echarts = echarts;
} else {
    // 生产环境下 echarts 已通过 CDN 加载
    Vue.prototype.$echarts = window.echarts;
}
// //v-charts与echarts5不兼容
// import VCharts from 'v-charts'
// Vue.use(VCharts);
// Vue._watchers = Vue.prototype._watchers = [];//解决报错用的

//引入ECharts
// 开发环境下导入 vue-echarts，生产环境使用 CDN 加载的 echarts
if (process.env.NODE_ENV !== 'production') {
    const VueECharts = require('vue-echarts');
    Vue.component('ECharts', VueECharts.default);
} else {
    // 生产环境下使用全局 echarts 创建组件
    Vue.component('ECharts', {
        props: ['option', 'theme', 'autoresize'],
        template: '<div ref="chart" style="width:100%;height:100%;"></div>',
        mounted() {
            this.chart = window.echarts.init(this.$refs.chart, this.theme);
            this.chart.setOption(this.option);
            if (this.autoresize) {
                window.addEventListener('resize', this.chart.resize);
            }
        },
        watch: {
            option: {
                deep: true,
                handler(val) {
                    this.chart.setOption(val);
                }
            }
        },
        beforeDestroy() {
            if (this.autoresize) {
                window.removeEventListener('resize', this.chart.resize);
            }
            this.chart.dispose();
        }
    });
}

// 将 dayjs 替代 moment 添加到 Vue 原型上
Vue.prototype.$moment = dayjs;
// 将 lodash 添加到 Vue 原型上
Vue.prototype.$_ = _;

Vue.prototype.$cache = initCacheFun(false);
Vue.prototype.$session = initCacheFun(true);
Vue.use(anime);
Vue.use(global);


getBrowserKeyAsync();
Vue.config.productionTip = false

//// 全局错误
// Vue.config.errorHandler = function (err, vm, info) {
//     // handle error
//     console.error(`Error in ${info}: ${err.toString()}`);
// };

new Vue({
    router, // 挂载路由
    render: h => h(App),
}).$mount('#app')
